/**
 * @file    LegacyTableBody.tsx
 * @scope   VIEW
 * @summary Picks what the legacy widget body shows: line chart → horizontal bar chart → table.
 * @consumes ReactECharts, HorizontalBarChart, react-data-table, SortIcon
 * @produces JSX only
 * @sideEffects None — row clicks are delegated through props.
 */
import React from 'react';
import ReactECharts from 'echarts-for-react';
import DataTable from 'react-data-table-component';
import HorizontalBarChart from 'components/Charts/HorizontalBarChart/HorizontalBar';
import SortIcon from 'core-ui/Sort/Sort';
import { TableState } from 'components/DynamicTable/common/types';

export interface LegacyTableBodyProps {
  showLineChart: boolean;
  chartView: boolean;
  echartRef: React.RefObject<any>;
  lineChartOptions: any;
  lineChartHeight: number;
  chartData: any;
  options: any;
  widgetProps: any;
  table?: TableState;
  dataTableProps: any;
  sortDirection: string;
  onRowClicked: (row: any) => void;
  loading?: boolean;
}

const LegacyTableBody: React.FC<LegacyTableBodyProps> = ({
  showLineChart,
  chartView,
  echartRef,
  lineChartOptions,
  lineChartHeight,
  chartData,
  options,
  widgetProps,
  table,
  dataTableProps,
  sortDirection,
  onRowClicked,
  loading,
}) => {
  if (showLineChart) {
    return (
      <ReactECharts
        ref={echartRef}
        opts={{ renderer: 'svg' }}
        option={lineChartOptions}
        style={{ width: '100%', height: lineChartHeight }}
      />
    );
  }
  if (chartView) {
    return (
      <HorizontalBarChart colors={['']} options={options} {...widgetProps} response={chartData} />
    );
  }
  if (table?.columns && Array.isArray(table?.data)) {
    return (
      <DataTable
        {...dataTableProps}
        columns={table.columns}
        data={table.data}
        onRowClicked={onRowClicked}
        sortIcon={<SortIcon status={sortDirection} />}
        progressPending={loading}
      />
    );
  }
  return null;
};

export default LegacyTableBody;
